import {ENDPOINT_REGISTRATION} from 'common/endpoints';
import {commonJwtHeader} from 'common/utils';

const confirmRegistration = (token, email) => {
  return fetch(`${ENDPOINT_REGISTRATION}confirmation`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'cache-control': 'no-cache',
      pragma: 'no-cache',
    },
    body: JSON.stringify({email, token}),
  });
};

export default {
  confirmRegistration,
};
